import { render, staticRenderFns } from "./ObjectGrid.vue?vue&type=template&id=061fe5f3&scoped=true"
import script from "./ObjectGrid.vue?vue&type=script&lang=js"
export * from "./ObjectGrid.vue?vue&type=script&lang=js"
import style0 from "./ObjectGrid.vue?vue&type=style&index=0&id=061fe5f3&prod&scoped=true&lang=scss"
import style1 from "./ObjectGrid.vue?vue&type=style&index=1&id=061fe5f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061fe5f3",
  null
  
)

export default component.exports